import { useLazyQuery, useQuery } from "@apollo/client/react"; import { useEffect, useMemo, useState } from "react";

import { GET_USUARIO_DELEGACION_ORIGEN } from "../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen";
import GET_GRILLA_ENVIOS, { adaptEnviosArray } from "../../../data/graphQL/queries/GestionEnvios/allEnvios";
import { TAB_AUTORIZAR_ID } from "../components/GestionEnviosContent";

const userId = sessionStorage.getItem("idUsuario");

export function useEnviosRows({
  filters,
  estadoEnvio,
  activeTabId,
  handleChangeFilters,
  resetInitialValues
}) {
  const [rows, setRows] = useState([]);
  const [originalDataAutorizar, setOriginalDataAutorizar] = useState([]);
  const [originalDataAutorizados, setOriginalDataAutorizados] = useState([]);

  const [getEnvios, { data: dataEnvios, loading: loadingEnvios }] =
    useLazyQuery(GET_GRILLA_ENVIOS, {
      fetchPolicy: "no-cache"
    });

  useEffect(() => {
    if (!dataEnvios) return;
    const dataAutorizarAdapted = adaptEnviosArray(dataEnvios?.autorizar);
    const dataAutorizadosAdapted = adaptEnviosArray(dataEnvios?.autorizados);
    setOriginalDataAutorizar(dataAutorizarAdapted);
    setOriginalDataAutorizados(dataAutorizadosAdapted);

    const dataFilteredFromClientSide = applyClientSideFilters(
      activeTabId === TAB_AUTORIZAR_ID ? dataAutorizarAdapted : dataAutorizadosAdapted,
      filters.txtFiltro
    );

    setRows(dataFilteredFromClientSide);
  }, [dataEnvios]);


  const { data: dataUsuarioDelegacion, loading: loadingUsuarioDelegacion } =
    useQuery(GET_USUARIO_DELEGACION_ORIGEN, {
      fetchPolicy: "no-cache",
      variables: { idUsuario: JSON.parse(userId, 10) }
    });

  useEffect(() => {
    if (!dataUsuarioDelegacion || loadingUsuarioDelegacion) return;
    const { success, valorEsperado } = dataUsuarioDelegacion?.usuarioFull ?? {};
    if (success) {
      const deleg = valorEsperado.delegacionOrigen;
      sessionStorage.setItem("delegacionOrigen", deleg);

      if (filters.idDelegacion === 0) {
        handleChangeFilters("idDelegacion", deleg);
      }

      handleSearch(deleg);
    }
  }, [dataUsuarioDelegacion, loadingUsuarioDelegacion]);

  const handleSearch = (idDelegacionParam) => {
    const idDelegacion = filters.idDelegacion || idDelegacionParam;

    resetInitialValues();

    getEnvios({
      variables: {
        idDelegacion
      }
    });
  };

  const applyTextFilter = (data, textFilter) => {
    const inputBuscar = textFilter?.trim().toUpperCase();

    if (inputBuscar === "") return data;

    const dataFiltered = data.filter((envio) => {
      const idOrdenPedido = envio.idOrdenPedido.toString().toUpperCase();
      const codSAP = envio.codSAP.toString().toUpperCase();
      const delegacion = envio.delegacion.toString().toUpperCase();
      const idEvaluacion = envio.idEvaluacion.toString().toUpperCase();
      const idPaciente = envio?.idPaciente?.toString().toUpperCase() || "";
      const paciente = envio?.paciente?.toString().toUpperCase() || "";
      const fechaEntrega = envio?.fechaEntrega?.toString().toUpperCase() || "";
      const fechaAutorizar = envio.fechaAutorizar?.toString().toUpperCase() || "";
      const usuarioAutorizar = envio.usuarioAutorizar?.toString().toUpperCase() || "";

      return (
        idOrdenPedido.includes(inputBuscar) ||
        codSAP.includes(inputBuscar) ||
        delegacion.includes(inputBuscar) ||
        idEvaluacion.includes(inputBuscar) ||
        idPaciente.includes(inputBuscar) ||
        paciente.includes(inputBuscar) ||
        fechaEntrega.includes(inputBuscar) ||
        fechaAutorizar.includes(inputBuscar) ||
        usuarioAutorizar.includes(inputBuscar));

    });

    return dataFiltered;
  };

  const applyClientSideFilters = (data, textFilter) => {
    const dataFilteredByText = applyTextFilter(data, textFilter);
    return dataFilteredByText;
  };

  const totalCount = useMemo(() => rows.length || 0, [rows]);

  return {
    rows,
    setRows,
    originalDataAutorizar,
    originalDataAutorizados,
    totalCount,
    loading: loadingEnvios || loadingUsuarioDelegacion,
    handleSearch,
    applyTextFilter,
    applyClientSideFilters
  };
}